// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__1X5p1","muted":"RssDirective_muted__Z+n2E"};